import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Chip } from "@mui/material";

const chatFilterTabs = ["ALL", "UNREAD"];

const ChatFilterTabs = ({ isChatLoading }: { isChatLoading: boolean }) => {
  const { t } = useTranslation("chat");

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab")?.toUpperCase() ?? "ALL";

  const handleOnChangeTab = (tab: string) => {
    const searchParams = new URLSearchParams(location.search);
    if (tab === "ALL") {
      searchParams.delete("tab");
    } else {
      searchParams.set("tab", tab.toLowerCase());
    }
    navigate({ search: searchParams.toString() });
  };

  return (
    <Box sx={styles.filterTabsContainer}>
      {chatFilterTabs.map((tab) => (
        <Chip
          key={tab}
          label={t(tab)}
          onClick={() => handleOnChangeTab(tab)}
          sx={styles.filterChip(currentTab == tab)}
          disabled={isChatLoading}
        />
      ))}
    </Box>
  );
};

export default ChatFilterTabs;

const styles = {
  filterTabsContainer: {
    display: "flex",
    gap: "17px",
  },
  filterChip(isActive: boolean) {
    return {
      padding: "4px 10px",
      borderRadius: "50px",
      minWidth: "50px",
      fontFamily: "Montserrat",
      fontSize: "14px",
      lineHeight: "24px",

      background: isActive ? "#E7EFED" : "#FFFFFF",
      color: isActive ? "#106048" : "#707070",
      fontWeight: isActive ? 600 : 400,
    };
  },
};
